// extracted by mini-css-extract-plugin
module.exports = {"accessory":"FancyHR_accessory__KYDLw"};